/**
 * <s-share-button data-url="…" data-title="…" data-copied="Link copied"> — opens the device share sheet
 * when available, otherwise copies the link and announces it in [data-share-status].
 */
class SShareButton extends HTMLElement {
  #ac;

  connectedCallback() {
    this.button = this.querySelector('button');
    this.status = this.querySelector('[data-share-status]');
    if (!this.button) return;
    this.#ac = new AbortController();
    this.button.addEventListener('click', () => this.#share(), { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
    clearTimeout(this.timer);
  }

  async #share() {
    const url = this.dataset.url || window.location.href;
    const title = this.dataset.title || document.title;
    if (navigator.share) {
      try {
        await navigator.share({ title, url });
      } catch {
        // The shopper closed the share sheet.
      }
      return;
    }
    try {
      await navigator.clipboard.writeText(url);
      if (!this.status) return;
      this.status.textContent = this.dataset.copied || '';
      clearTimeout(this.timer);
      this.timer = setTimeout(() => (this.status.textContent = ''), 2500);
    } catch {
      // Clipboard blocked; nothing else to do.
    }
  }
}

if (!customElements.get('s-share-button')) customElements.define('s-share-button', SShareButton);
